module.exports = __webpack_public_path__ + "static/img/English_Star.f6550843.png";